import React from 'react';
import classnames from 'classnames';
import { scaleToSize } from '../_helpers';
import MediaService from '../../utils/DeviationMediaService';
import BlurredBackground from '../Full/_partials/BlurredBackground';
import hiddenStyles from './Hidden.scss';
const HiddenLayout = ({ icon, compact, showBackground = true, strict, title, text, className, button, secondaryButton, deviation, width, height })=>{
    const background = MediaService.getSmallestThumb(deviation);
    const fullImage = MediaService.getFullviewForSize(deviation, width, height);
    const childBoxSize = fullImage ? scaleToSize(fullImage, {
        width,
        height
    }) : {
        width,
        height
    };
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            width,
            height
        },
        className: classnames(className, hiddenStyles['root'], compact && hiddenStyles['compact'], strict && hiddenStyles['strict'])
    }, /*#__PURE__*/ React.createElement("div", {
        style: childBoxSize,
        className: hiddenStyles['blocked-placeholder']
    }, showBackground && background && /*#__PURE__*/ React.createElement(BlurredBackground, {
        imageUrl: background.src,
        clientSideBlur: true
    }), /*#__PURE__*/ React.createElement("div", {
        className: hiddenStyles['blocked-wrap']
    }, /*#__PURE__*/ React.createElement("div", {
        className: hiddenStyles['blocked-icon']
    }, icon), title && /*#__PURE__*/ React.createElement("div", {
        className: hiddenStyles['blocked-title']
    }, title), Array.isArray(text) ? text.map((node, idx)=>node && /*#__PURE__*/ React.createElement("div", {
            key: idx,
            className: title ? hiddenStyles['blocked-text'] : hiddenStyles['blocked-text-large']
        }, node)) : text && /*#__PURE__*/ React.createElement("div", {
        className: title ? hiddenStyles['blocked-text'] : hiddenStyles['blocked-text-large']
    }, text), button, secondaryButton)));
};
HiddenLayout.displayName = 'HiddenLayout';
export default HiddenLayout;
